import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  logoUrl: string;
}

const Logo: React.FC<LogoProps> = ({ className = '', logoUrl }) => {
  return (
    <Link to="/" className={`flex items-center space-x-3 ${className}`}>
      <img
        src={logoUrl}
        alt="Animatronic Database Logo"
        className="h-8 w-8 object-contain"
      />
      <span className="text-xl font-bold text-content-primary">
        Animatronic Database
      </span>
    </Link>
  );
};

export default Logo;